import React, { useState } from 'react';
import PropTypes from 'prop-types';

import JPWidget from '../widget/JPWidget';
import TranspennineRoverCTA from './TranspennineRoverCTA';
import config from '../../config';
import FeatureFlagStore from '../../stores/FeatureFlagStore';
import FamilyVerificationStore from '../../stores/FamilyVerificationStore';
import useStoreState from '../../stores/useStoreState';
import User from '../../records/User';
import t from '../../lib/I18n';


const SearchWithoutMap = ({ user, performSearch }) => {
    const [showJPWidget, setShowJPWidget] = useState(false);

    const enableTPEStaffRover = FeatureFlagStore.get('enableTPEStaffRover');

    const isVerified = useStoreState(FamilyVerificationStore, 'isVerified');

    const showTranspennineRoverCTA = enableTPEStaffRover && isVerified;

    const handleShowJPWidget = () => {
        setShowJPWidget(true);
    };

    return (
        <div className="se-main-page">
            {showTranspennineRoverCTA && !showJPWidget && (
                <React.Fragment>
                    <h1>{t('promotion.tocFamily.rover.header')}</h1>
                    <TranspennineRoverCTA />
                    <div className="toc-family-search-other-journeys">
                        <a href="#" onClick={handleShowJPWidget}>
                            {t('promotion.tocFamily.rover.searchOtherJourneys')}
                        </a>
                    </div>
                </React.Fragment>
            )}

            {(!showTranspennineRoverCTA || showJPWidget) && (
                <React.Fragment>
                    <h1>{t('pageTitles.se.main.page')}</h1>
                    <JPWidget
                        params={{
                            brand: config.get('tocCode'),
                            apiUrl: `https://${config.get('apiHost')}`,
                            stylesheetUrl: config.get('jpWidgetStylesheetUrl'),
                            vertical: false,
                            hideNavigation: false,
                            disableBackground: false,
                            hidePromotionalText: false,
                            enableDaySave:
                                FeatureFlagStore.get('enableDaySave') &&
                                !FeatureFlagStore.get('enableHiddenDaySave'),
                            enableRoversRangers: FeatureFlagStore.get('enableRoversRangers'),
                            enableTPERover: FeatureFlagStore.get(
                                'enableTPERover',
                            ),
                            enableSmartCarnet: FeatureFlagStore.get('enableSmartCarnet'),
                            disabledTabs: '',
                            searchCallBack: typeof performSearch === 'function' ? performSearch : () => {},
                            enableKentRover: FeatureFlagStore.get('enableKentRover'),
                            enableBestFareFinderAndRecentOrders: config.get(
                                'enableBestFareFinderAndRecentOrdersJPWidget',
                            ),
                            context: 'BOOKING_ENGINE',
                            enablePromoDiscount:
                                FeatureFlagStore.get('enablePromoDiscount') ||
                                FeatureFlagStore.get('enableDiscountCode'),
                        }}
                        userId={user && user.id}
                    />
                </React.Fragment>
            )}
        </div>
    );
};

SearchWithoutMap.propTypes = {
    user: PropTypes.instanceOf(User).isRequired,
    performSearch: PropTypes.func.isRequired,
};

SearchWithoutMap.defaultProps = {
    user: {},
    performSearch: () => {},
};

export default SearchWithoutMap;



// WEBPACK FOOTER //
// ./src/components/point/SearchWithoutMap.js